type Config = {
  BASE_URL: string;
};

type Environment = "development" | "qa" | "production";

const envConfigs: Record<Environment, Config> = {
  development: {
    BASE_URL: "http://localhost:3000/banking/v1",
  },
  qa: {
    BASE_URL: "https://pospapiqa.paisabazaar.ae/banking/v1",
  },
  production: {
    BASE_URL: "https://api.paisabazaar.ae",
  },
};

// Get environment from VITE_APP_ENV or fallback to development
const getEnvironment = (): Environment => {
  const env = import.meta.env.VITE_APP_ENV as Environment;
  if (env && envConfigs[env]) {
    return env;
  }
  return "development";
};

const currentConfig = envConfigs[getEnvironment()];

export default currentConfig;
